import { useEffect } from 'react';

export const useImagePreload = (imageUrls) => {
  useEffect(() => {
    if (!Array.isArray(imageUrls)) return;

    imageUrls.forEach(url => {
      if (typeof url === 'string') {
        const img = new Image();
        img.src = url;
      }
    });
  }, [imageUrls]);
}; 